export default __webpack_public_path__ + "static/media/SuAUEmpty.2395cdc1.svg";